module.exports = __webpack_public_path__ + "static/media/app7.82f4ca87.png";